import EventEmitter from 'eventemitter3'
import debounce from 'lodash/debounce'

const bus = new EventEmitter()

window.addEventListener('touchstart', handleTouchStart, false)
window.addEventListener('resize', debounce(_ => bus.emit('window-resize'), 100), false)

function handleTouchStart(evt) {
  bus.emit('is-touch', { origEvent: evt })
  window.removeEventListener('touchstart', handleTouchStart)
}

export default bus
